import { ActionTypes } from "@/App/constants/actionTypes";
import { BatchManualClaimTypes, GeneralTypes } from "@/types";

type GetManualClaimListAction = {
  type: typeof ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST;
  payload: {
    queryOptions: GeneralTypes.QueryOptions;
  };
};

export const getManualClaimList = (data: { queryOptions: GeneralTypes.QueryOptions }): GetManualClaimListAction => {
  return {
    type: ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST,
    payload: data,
  };
};

type GetManualClaimListResultAction = {
  type: typeof ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST_RESULTS;
  payload: {
    results: Array<BatchManualClaimTypes.BatchManualClaim>;
    result_count: string;
  };
};

export const getManualClaimListResults = (data: {
  results: Array<BatchManualClaimTypes.BatchManualClaim>;
  result_count: string;
}): GetManualClaimListResultAction => {
  return {
    type: ActionTypes.GET_BATCH_TRANSMISSION_MANUAL_CLAIM_LIST_RESULTS,
    payload: data,
  };
};

export type GetBatchManualClaimListActions = GetManualClaimListAction | GetManualClaimListResultAction;
